import { ModalActions } from './Actions';
import { ModalContainer } from './Container';
import { ModalContent } from './Content';
import { ModalHeader } from './Header';
import { ModalRoot } from './Root';

export const Modal = {
  Root: ModalRoot,
  Container: ModalContainer,
  Header: ModalHeader,
  Content: ModalContent,
  Actions: ModalActions,
};
